import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";

const CostColumnOptions = ({
  includeDefaultPuCost,
  toggleIncludeDefaultPuCost,
  includeDefaultPuPerUnitCost,
  toggleIncludeDefaultPuPerUnitCost,
}) => {
  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          sx={{ marginLeft: -3 }}
          checked={includeDefaultPuCost}
          onChange={() => toggleIncludeDefaultPuCost(!includeDefaultPuCost)}
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 700, marginRight: 1 }}>
          Include Default PU Cost Column
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          sx={{ marginLeft: -3 }}
          checked={includeDefaultPuPerUnitCost}
          onChange={() =>
            toggleIncludeDefaultPuPerUnitCost(!includeDefaultPuPerUnitCost)
          }
        />
        <Typography variant="subtitle1" sx={{ fontWeight: 700, marginRight: 1 }}>
          Include Default PU Per Unit Cost Column
        </Typography>
      </Box>
    </Box>
  );
};

export default CostColumnOptions;
